












import { defineComponent, computed } from '@vue/composition-api';
import OutlinedIcon from './OutlinedIcon.vue';

export default defineComponent({
    components: {
        OutlinedIcon,
    },
  inheritAttrs: false,
    emits: ['click'],
    setup(_, { emit }) {
        const onClick = () => {
            emit('click');
        };

        return {
            onClick,
        };
    },
});
